import { s } from './icon.style'
import React from 'react'
import type { IconProps } from '../iconProps'

export const ChevronDoubleRightIcon = React.forwardRef<SVGSVGElement, IconProps>(
  ({ size = 16, name = 'icon', color, style, ...props }: IconProps, ref) => {
    return (
      <svg
        viewBox="0 0 24 24"
        css={s}
        style={{ width: size, color, ...style }}
        data-svg-name={name}
        {...props}
        ref={ref}
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12 16.59L16.58 12L12 7.41L13.41 6L19.41 12L13.41 18L12 16.59Z"
          fill="black"
          fill-opacity="0.87"
        />
        <path
          d="M5 16.59L9.58 12L5 7.41L6.41 6L12.41 12L6.41 18L5 16.59Z"
          fill="black"
          fill-opacity="0.87"
        />
      </svg>
    )
  }
)
